import React, { Component } from 'react';
import { urls } from '../../constants';
import i18next from "../../i18n";
import * as ModalDialogsTemplates from '../ModalDialogsTemplates';
import { hideModalDialog, showModalDialog } from '../ModalDialog';
export class YoucontrolSettingsForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sending: true,
            submitted: false,
            wasChanged: false,
            youControlKey: ''
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.onCancel = this.onCancel.bind(this);
    }
    async loadData() {
        const response = await fetch('/admin/geyYoucontrolKey', { method: 'GET' });
        if (response.ok) this.setState({ wasChanged: false, youControlKey: await response.text(), submitted: false });
        else ModalDialogsTemplates.unknownErrorMessageDialog();
        this.setState({ sending: false });
    }
    onCancel() {
        this.loadData();
    }
    componentDidMount() {
        this.loadData();
    }
    handleChange(event) {
        const { name, value } = event.target;
        this.setState({
            [name]: value,
            wasChanged: true
        });
    }
    handleSubmit(event) {
        event.preventDefault();
        const { sending, youControlKey } = this.state;
        this.setState({ submitted: true });
        if (!sending && youControlKey) {
            this.setState({ sending: true });
            this.submit(youControlKey);
        }
    }
    async submit(key) {
        const currentObject = this;
        const formData = new FormData();
        formData.append('key', key);
        function onClose() {
            hideModalDialog("loadingDialog");
            if (currentObject.props.onSubmitedHandler)
                currentObject.props.onSubmitedHandler();
            currentObject.loadData();
        }
        fetch('/admin/updateYoucontrolKey', {
            method: 'POST',
            headers: { "Contetnt-Type": "multipart/form-data" },
            body: formData
        })
            .then((response) => {
                if (response.status === 403) {
                    window.onbeforeunload = null;
                    window.location.href = urls.accessDeniedUrl;
                    return;
                }
                showModalDialog("loadingDialog", i18next.t("done"), "", <div className="info-message">{response.ok ? i18next.t("youControlKeySuccessfullyUpdated") : i18next.t("unknownErrorMessage")}</div>, "feedPopup", true, [{ title: i18next.t("ok"), clickHandler: onClose, class: "btn-primary" }], onClose);
                if (response.ok) currentObject.setState({ sending: false });
            });
    }
    render() {
        const { sending, submitted, youControlKey, wasChanged } = this.state;
        return (
            <div className="modal-body">
                <div className="form-block large-form settings-form">
                    <form name="form" className="popupSimple file-upload-form" onSubmit={this.handleSubmit}>
                        <div className="row">
                            <div className="form-group col-sm-6 col-xs-6">
                                <label htmlFor="youControlKey" className="required">YouControl API key</label>
                                <input className="form-control" name="youControlKey" value={youControlKey} onChange={this.handleChange} disabled={(sending ? 'disabled' : '')} />
                                {submitted && !youControlKey &&
                                    <div className="help-block">{i18next.t("requiredField")}</div>
                                }
                            </div>
                            {submitted && !youControlKey &&
                                <div className='form-group col-sm-12 col-xs-12'>
                                </div>
                            }
                        </div>
                        <div className="form-group form-group__last">
                            <button className="btn btn-primary">{i18next.t("save")}</button>
                            {wasChanged &&
                                <button type="button" className="btn btn-secondary" onClick={this.onCancel}>{i18next.t("cancel")}</button>
                            }
                            <div className="required-label">
                                <label className="required" />{i18next.t("requiredFields")}
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}
